import {BrowserCacheLocation, PublicClientApplication} from '@azure/msal-browser';
import {AppConfig} from './app.config';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALFactory() {
  // Some deployed configurations contain the API audience here (api://<application-id>).
  // MSAL requires the Application (client) ID itself; the audience remains part of the requested scope.
  const clientId = AppConfig.settings.auth.azureADClientId.replace(/^api:\/\//i, '');

  return new PublicClientApplication({
    auth: {
      clientId: clientId,
      redirectUri: window.location.href.includes('localhost') ? `http://${window.location.host}` : `https://${window.location.host}`,
      authority: AppConfig.settings.auth.azureADAuthority,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
    system: {}
  });
}
